import { makeRequest } from '../../../../lib/api';
import {
  CreateChecklistRequest,
  UpdateChecklistRequest,
} from '../../api/checklistApi';

const ORDER_CHECKLIST_PATH = '/v1/order_checklist_items';

const checklistController = {
  getChecklist: (orderId: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_CHECKLIST_PATH }?orderId=${ orderId }`);
  },

  createChecklist: (request: CreateChecklistRequest): Promise<any> => {
    return makeRequest('post', ORDER_CHECKLIST_PATH, request);
  },

  updateChecklist: (request: UpdateChecklistRequest): Promise<any> => {
    return makeRequest('put', `${ ORDER_CHECKLIST_PATH }/${ request.id }`, { checked: request.checked });
  },

  deleteChecklist: (id: string): Promise<any> => {
    return makeRequest('delete', `${ ORDER_CHECKLIST_PATH }/${ id }`);
  },
};

export { checklistController };
